import React from 'react';

export const DataTableEmptyDrawer = () => {
  return <div />;
};
